import React from 'react';
import AddCourseForm from './AddCourseForm';
import Dashboard from './Dashboard';

const AddCourse = () => (
  <div className="wrapper">
    <Dashboard />
    <AddCourseForm />
  </div>
);

export default AddCourse;
